import Vue from 'vue'
export default {
  timelinePresent: 'present',
  timelinePast:'past',
  timelineFutur: 'futur',
  isValid(date) {
    return Vue.moment(date).isValid()
  },
  timelineLabel(timeline) {
    switch(timeline) {
      case this.timelinePast:
        return Core.Definition.getDefinition('Terminé')
        break
      case this.timelineFutur:
        return Core.Definition.getDefinition('À venir')
        break
      case this.timelinePresent:
        return Core.Definition.getDefinition('En cours')
        break
    }
  },
  timeline(start, end, date) {
    if (date === undefined) {
      date = Vue.moment()
    }
    let isBetween = this.isBetween(date, start, end)
    if (isBetween) {
      return this.timelinePresent
    } else {
      let isBefore = this.isBefore(date, start)
      if (isBefore) {
        return this.timelineFutur
      } else {
        return this.timelinePast
      }
    }
  },
  readableTimeline(start, end) {
    return this.timelineLabel(this.timeline(start, end))
  },
  isBetween(date, start, end) {
    return Vue.moment(date).isBetween(start, end)
  },
  isBefore(date, target) {
    return Vue.moment(date).isBefore(target)
  },
  isSameOrBefore(date, target) {
    return Vue.moment(date).isSameOrBefore(target)
  },
  isAfter(date, target) {
    return Vue.moment(date).isBefore(target)
  },
  isSameOrAfter(date, target) {
    return Vue.moment(date).isSameOrAfter(target)
  },
  readableDate(date, format) {
    if(format === undefined) {
      format = 'DD MMM YYYY'
    }
    return this.format(date, format)
  },
  readableTimes(start, end) {
    let format = 'HH:mm'
    return this.format(start, format) + ' - ' + Core.Date.format(end, format)
  },
  getToday(format) {
    if (format === undefined) {
      format = 'YYYY-MM-DD'
    }
    return Vue.moment().format(format)
  },
  format(date, format) {
    if (date !== '' && date !== undefined && Vue.moment(date).isValid()) {
      if (format === undefined) {
        format = 'DD MMM YYYY'
      }
      return Vue.moment(date).format(format)
    }
    return ''
  },
  calc(period, periodLength, format, date) {
    if (date === undefined || date === '') {
      date = Vue.moment()
    }
    if (format === undefined || format === '') {
      format = 'YYYY-MM-DD'
    }
    if (format === 'date') {
      return Vue.moment(date).add(periodLength, period)
    }
    return Vue.moment(date).add(periodLength, period).format(format)
  },
  dayOfWeekLabel(day) {
    let daysOfWeek = [
      Core.Definition.getDefinition('Lundi'),
      Core.Definition.getDefinition('Mardi'),
      Core.Definition.getDefinition('Mercredi'),
      Core.Definition.getDefinition('Jeudi'),
      Core.Definition.getDefinition('Vendredi'),
      Core.Definition.getDefinition('Samedi'),
      Core.Definition.getDefinition('Dimanche')
    ]
    return daysOfWeek[day]
  },
  daysOfWeekOptions(date, startOfFormat, labelFormat, valueFormat, days){

    if (days === undefined) {
      days = 7
    }

    if (startOfFormat === undefined) {
      startOfFormat = 'isoWeek'
    }

    if (labelFormat === undefined) {
      labelFormat = 'dddd, DD MMMM YYYY'
    }

    if (valueFormat === undefined) {
      valueFormat = 'YYYY-MM-DD'
    }

    let options = []
    for(let day = 0; day < days; day ++) {
      options.push(
          {
            value: Vue.moment(date).startOf(startOfFormat).add('day', day).format(valueFormat),
            label: Vue.moment(date).startOf(startOfFormat).add('day', day).format(labelFormat)
          }
      )
    }
    return options
  }
}
